import styled from "styled-components";

import { Tab as TabMui } from "@libraries/mui/components";

import { windowWidth } from "@styles/global";

const Tab = styled(TabMui)`
  color: ${({ theme }) => theme.brand.ink} !important;
  background-color: #fff !important;
  border: 1px solid ${({ theme }) => theme.brand.line} !important;
  text-transform: none !important;
  padding: 0 5px !important;
  min-height: 35px !important;
  max-height: 35px !important;
  min-width: 125px !important;
  max-width: 125px !important;
  border-radius: 10px !important;
  font-size: 12px !important;
  transition: background-color 0.15s, color 0.15s, border-color 0.15s;

  :hover {
    border-color: ${({ theme }) => theme.brand.soft} !important;
  }

  &.Mui-selected {
    color: #fff !important;
    background-color: ${({ theme }) => theme.brand.navy} !important;
    border-color: ${({ theme }) => theme.brand.navy} !important;
  }

  &.Mui-selected:hover {
    background-color: ${({ theme }) => theme.brand.navyHover} !important;
    border-color: ${({ theme }) => theme.brand.navyHover} !important;
  }

  &.Mui-disabled {
    background-color: #fff !important;
    opacity: 0.5;
  }

  @media ( max-width: ${windowWidth.laptop.large} ) {
    min-height: 30px !important;
    max-height: 30px !important;
    font-size: 11px !important;
    min-width: 115px !important;
    max-width: 115px !important;
  }

`;

export { Tab };
